import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import '@/component'
import '@/utils/global.mixin'
import '@/utils/dialog'

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        let { instance } = this.$launch('toast')
        Vue.prototype.$toast = instance
    }
}).$mount('#app')
